import api from 'api/axios';

export async function getPublicRegistrations(params) {
  try {
    return await api.get("/admin/registrations", { params });
  } catch (err) {
    return err.response;
  }
}

export async function exportPublicRegistrations(params) {
  return api.get("/admin/registrations/export", {
    params,
    responseType: "blob",
  });
}
